import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { NavigationButtonType } from '../types';

/**
 * @summary This component can be used to display a navigation button
 * @description The navigation button can be used to navigate through different sections of a page or application
 * @tag gz-navigation-button
 */
@customElement('gz-navigation-button')
export class GzNavigationButtonWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  buttonType: NavigationButtonType = NavigationButtonType.TOP;

  @property({ type: String, attribute: true, reflect: true })
  text = '';

  private readonly iconColor = 'var(--chart-300-icon-buttons)';
  private readonly iconSuffixes = {
    [NavigationButtonType.TOP]: '_prev',
    [NavigationButtonType.BOTTOM]: '_next',
  };

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <button class="nav-button ${NavigationButtonType.TOP}">
        <gz-icon
          name="ds-icon-panel${this.iconSuffixes[this.buttonType]}"
          size="24"
          color="${this.iconColor}"
        ></gz-icon>
        <span id="navButtonTopText">${this.text}</span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-navigation-button': GzNavigationButtonWebComponent;
  }
}
